export default __webpack_public_path__ + "static/media/3-PARENTS-EN.dc8a58ad.pdf";